import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Drawer, Select, Form, Input, Button } from 'antd';
import './BrandCompanySelectComponent.styles.scss';
import { dispatch, useGlobalState } from '../../../store/state';
import { CompanyList } from '../../../apis/Brand/Company/CompanyList';
import { IoCreateOutline } from 'react-icons/io5';
import { CreateCompany } from '../../../apis/Brand/Company/CreateCompany';
import BrandCreateCompanyComponent from './BrandCreateCompanyComponent';
import { GetCompanyList } from '../../../utils/GetCompanyList';
const { Option, OptGroup } = Select;
const BrandCompanySelectComponent = () => {
  const history = useHistory();
  const [user] = useGlobalState('user');
  const [company] = useGlobalState('company');

  // const [formCreateCompany] = Form.useForm();
  // const GetCompanyList =(val,def,newCompany) =>{
  //     CompanyList(user.accessToken).then(({response}) => {
  //         function findId(companies){ return companies.id === val }
  //         dispatch({
  //             type:'SET_COMPANY',
  //             payload:{
  //                 ...company,
  //                 all:response,
  //                 selected:def ? (company.selected || response[0]) : response.find(findId),
  //                 // credit:{}
  //             }
  //         })
  //     })
  //     // console.log("comp",company.selected)
  // }
  useEffect(() => {
    GetCompanyList(null, true, user.accessToken, company);
  }, []);

  const [visible, setVisible] = useState(false);
  const showDrawer = () => {
    setVisible(true);
  };
  const onClose = () => {
    setVisible(false);
  };
  const companyChange = (value)=>{
    if (value == 'create') {
      showDrawer();
    } else {
      // console.log("ompchnage",value)
      function findId (companies) {
        return companies.id === value;
      }
      dispatch({
        type: 'SET_COMPANY',
        payload: {
          ...company,
          selected: company.all.find(findId) || company.selected,
          // credit:{}
        },
      });
      history.push('/brand');
    }
  };

  // const onFormSubmit =(value) =>{
  //     CreateCompany(user.accessToken,value).then(({response}) =>{
  //         GetCompanyList(response.id,false,true)
  //         formCreateCompany.resetFields();
  //         onClose();
  //     })
  // }
  return (
    <>
      <span className="company_selector ml-3">
        <h6>Selected Company</h6>
        <Select
          name="companySelector"
          value={company.selected && company.selected.id || undefined}
          // defaultValue={company.selected && company.selected.id || undefined}
          onChange={companyChange}
        >
          {company.all && company.all.map(({ id, companyname }) => (
            <Option key={id}
              value={id}>{companyname}</Option>
          ))}
          <OptGroup label="or">
            <Option value="create"
              style={{ paddingLeft: 12 }}><IoCreateOutline/> Create New</Option>
          </OptGroup>
        </Select>
      </span>
      <Drawer
        title="Create a new Company"
        placement="right"
        closable={true}
        onClose={onClose}
        visible={visible}
        width={280}
      >
        <BrandCreateCompanyComponent
          onClose={onClose}
        />
        {/* <Form
                    form={formCreateCompany}
                    layout="vertical"
                    name="createCompany"
                    requiredMark={false}
                    onFinish={onFormSubmit}
                >
                    <Form.Item
                        label="Enter your company name"
                        name="companyname"
                        rules={[{required:true,message: 'Please enter your company name'}]}
                    >
                        <Input size="large" type="text" placeholder="Eg: Lorem ipsum company" />
                    </Form.Item>
                    <div className="text-right pt-2">
                        <Button htmlType="submit" className="common_button">Create Company</Button>
                    </div>
                </Form> */}
      </Drawer>
    </>
  );
};

export default BrandCompanySelectComponent;
